import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixShareIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M18.4576 8.33906C20.0032 8.33906 21.2561 7.08616 21.2561 5.54063C21.2561 3.99509 20.0032 2.74219 18.4576 2.74219C16.9121 2.74219 15.6592 3.99509 15.6592 5.54063C15.6592 7.08616 16.9121 8.33906 18.4576 8.33906Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.58555 14.8C7.13108 14.8 8.38398 13.5471 8.38398 12.0016C8.38398 10.456 7.13108 9.20312 5.58555 9.20312C4.04001 9.20312 2.78711 10.456 2.78711 12.0016C2.78711 13.5471 4.04001 14.8 5.58555 14.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.4576 21.2609C20.0032 21.2609 21.2561 20.008 21.2561 18.4625C21.2561 16.917 20.0032 15.6641 18.4576 15.6641C16.9121 15.6641 15.6592 16.917 15.6592 18.4625C15.6592 20.008 16.9121 21.2609 18.4576 21.2609Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8.81934 13.4062L15.1904 17.1188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.1811 6.875L8.81934 10.5876"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
